import { getUser } from './userStorage';

export function authHeaders() {
    // return authorization header with jwt token
    let user = getUser();

    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        return {};
    }
}


// WEBPACK FOOTER //
// ./src/helpers/authHeaders.js